<div class="d-lg-block d-none">
  <fgb-banner [title]="'rewards.auction.text' | translate"></fgb-banner>
</div>

<div class="d-none d-lg-block">
  <fgb-balance-bar></fgb-balance-bar>
</div>

<div class="widget-mobile">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

  <div class="container mb-4 d-none d-lg-block">
    <div class="font-size-14 fw-bold text-center border border-disabled py-3 border-rounded bg-white">
      {{ 'rewards.sales.info' | translate }}
    </div>
  </div>

  <div class="container">
    <fgbcl-auction-list [defaultSort]="1"></fgbcl-auction-list>
  </div>
</div>
